import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  #titleService = inject(Title);
  #translate = inject(TranslateService);
  #titleSubject = new Subject<string>();

  constructor() {
    super();

    this.#titleSubject
      .pipe(switchMap((newTitle) => this.#translate.stream(newTitle)))
      .subscribe((newTitle) => {
        this.#titleService.setTitle(newTitle);
      });
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const newTitle = this.buildTitle(routerState);
    if (newTitle !== undefined) {
      this.#titleSubject.next(newTitle);
    }
  }
}
